export const BACKEND_STATE_CONSTANTS = {
  ACTIVE: 'ACTIVE',
  EXPIRING: 'EXPIRING',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED'
}

export const FRONTEND_STATE_CONSTANTS = {
  PENDING_UNSUBSCRIPTION: 'PENDING SUBSCRIPTION',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
}
// export backend state constants
export const { ACTIVE, EXPIRING, SUSPENDED, CANCELLED } =
  BACKEND_STATE_CONSTANTS

export const { PENDING_UNSUBSCRIPTION, UNSUBSCRIBED } = FRONTEND_STATE_CONSTANTS
/**
 * Mapping to convert backend states to states for CH user to show on dashboard
 */
export const backendStatesDashBoardMapping = {
  ACTIVE: ACTIVE,
  EXPIRING: PENDING_UNSUBSCRIPTION,
  SUSPENDED: SUSPENDED,
  CANCELLED: CANCELLED
}

/**
 * Mapping to convert backend states to dropdown fields on user actions
 */
export const backendStatesActionMapping = {
  ACTIVE: ACTIVE,
  CANCELLED: CANCELLED,
  EXPIRING: UNSUBSCRIBED,
  SUSPENDED: SUSPENDED
}

/**
 * @params {string} takes in state returned from backend
 * @return {string} frontend states for CH user
 */
export const mapStatesToFrontendDashboard = (state: string): string => {
  return backendStatesDashBoardMapping[state]
}

/**
 * @params {string} takes in state returned from backend
 * @return {string} frontend states for CH user on action menu
 */
export const mapStatesToFrontendDropdown = (state: string): string => {
  return backendStatesActionMapping[state]
}

/**
 * @params {string } takes in state from frontend
 * @return {string} backend states to send to api request
 */

export const mapStatesToBackendDropdown = (state: string): string => {
  let backendState = ''
  switch (state) {
    case ACTIVE:
      backendState = ACTIVE
      break
    case UNSUBSCRIBED:
      backendState = EXPIRING
      break
    default:
      backendState = ''
      break
  }
  return backendState
}

/**
 * @params {string } takes in state from frontend
 * @return {string} converted states to match backend
 */
export const mapStatesToBackendDashboard = (state: string): string => {
  const beState = Object.keys(backendStatesDashBoardMapping).find(
    (key) => backendStatesDashBoardMapping[key] === state
  )

  return beState ? beState : ''
}
